import React from "react";
import styles from "./PricingCard.module.css";

const PricingCard = ({ name, price, billing, popular, features, buttonText,setIsRegisterOpen }) => {
  return (
    <div className={`${styles.card} ${popular ? styles.popular : ""}`}>
      {popular && <div className={styles.badge}>MOST POPULAR</div>}

      <h2>{name}</h2>
      <h3>{price}</h3>
      {/* Features list */}
      <button className={popular ? styles.yelBtn : styles.blueBtn}  onClick={() => {
                setIsRegisterOpen(true);   // ✅ ONLY REGISTER
                // toggleMenu();
              }}>
        {buttonText}
      </button>
      <ul className={styles.featuresList}>
        {features.map((feature, index) => (
          <li key={index}>
            <span className={styles.tick}>✔</span>
          {feature}</li>
        ))}
      </ul>

      
    </div>
  );
};

export default PricingCard;
